import React from 'react';
import { Container } from '@chakra-ui/react';
import EmptyState from '../../common/EmptyState';

const EditNotAllowedPage = ({ type }) => {
  return (
    <Container display="flex" flexDir="column" flexGrow="1">
      <EmptyState
        heading="Edit via API Only"
        text={`You can’t edit the transit type ${type} in the dashboard.\nPlease use the API instead.`}
      />
    </Container>
  );
};

export default EditNotAllowedPage;
